export const formatDate = (d: string) => {
  const [yyyy, mm, dd] = d.split(/[/:\-T]/);

  return `${mm}/${dd}/${yyyy}`;
};

export const formatDateTime = (d: string) => {
  const [yyyy, mm, dd, hh, mi] = d.split(/[/:\-T]/);

  return `${mm}/${dd}/${yyyy} ${hh}:${mi}`;
};

export const getCurrentYear = () => new Date().getFullYear();

export const getNextHour = () => {
  const timeNow = new Date().getTime();
  return new Date(timeNow + 60 * 60 * 1000);
};

export const getNextTwoWeek = () => {
  const timeNow = new Date().getTime();
  return new Date(timeNow + 14 * 24 * 60 * 60 * 1000);
};
